import {
    useMutation,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import requests from 'app/requests/Lane/LaneAutoQuotation.requests'
import {
    Lane,
} from 'app/Apps/OrderManagement/Lanes/lanes.types'
import {
    AutomaticQuoteRequestParams,
} from 'app/Apps/OrderManagement/Orders/CustomerTransport/CreateAirlineLease/createCustomerTransportForm.types'
import simpleApi from 'app/services/simpleApi'

const useCreateAutomaticQuote = ({
    onSuccess,
}: {
    onSuccess: (data: Lane) => void
}) => {
    const token = useJWTToken()
    const {
        onError,
    } = useHandleStatusRequest({
        id: 'AutomaticQuote',
        title: 'Automatic Quote',
    })

    return useMutation({
        mutationFn: (data: AutomaticQuoteRequestParams) => {
            return simpleApi({
                ...requests.createAutomaticQuote({
                    data,
                }),
                token,
            })
        },
        onSuccess,
        onError,
    })
}

export default useCreateAutomaticQuote
